// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"41dfefaf","787":"026c2d18"}[chunkId] + ".chunk.js";
};